import React from 'react';
import classNames from 'clsx';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';

import { messages } from './messages';
import style from './style.module.less';
import { emptyObject } from 'ui-components/default-props/empty';
import { DEFAULTS } from '../../../ship-from/components/ship-from-dropdown/constants';
import { ValidationPropType } from '../../../ship-from/components/ship-from-dropdown/prop-types';

export const AddressDropdown = ({
  className,
  onAddressChange,
  selectedAddress = emptyObject,
  shipFroms,
  validation: { helperText, helperTextType } = DEFAULTS.validation,
}) => {
  const selectedShipFrom = shipFroms.find((shipFrom) => shipFrom.isDefault === true);

  const onChange = (id) => {
    const selected = shipFroms.find((shipFrom) => shipFrom.shipFromId === id);
    onAddressChange(selected);
  };

  return (
    <DropdownMenu
      className={classNames(style['select-address'], className)}
      dropdownMenuShouldHaveWidthOfButton
      fullWidth
      inlineMessage={helperText}
      inlineMessageType={helperTextType}
      value={selectedShipFrom}
    >
      <DropdownMenuToggler className={style['select-address-toggler']} theme='link'>
        <FormattedMessage {...messages.selectAddress} />
      </DropdownMenuToggler>
      {shipFroms.map((shipFrom) => {
        const { shipFromId, line1, line2, line3, city, state, countryCode, postalCode, originAddress } = shipFrom;
        return (
          <DropdownMenuItem key={shipFromId} name={shipFromId} onClick={onChange} selected={selectedAddress.shipFromId === shipFromId}>
            <div>{originAddress?.name}</div>
            <div>{`${line1}, ${line2 ? `${line2}, ` : ''}${line3 ? `${line3}, ` : ''} ${city} ${state} ${postalCode} ${countryCode}`}</div>
          </DropdownMenuItem>
        );
      })}
    </DropdownMenu>
  );
};

AddressDropdown.propTypes = {
  className: PropTypes.string,
  onAddressChange: PropTypes.func.isRequired,
  selectedAddress: PropTypes.object,
  shipFroms: PropTypes.arrayOf(
    PropTypes.shape({
      shipFromId: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      line1: PropTypes.string.isRequired,
      line2: PropTypes.string,
      line3: PropTypes.string,
      city: PropTypes.string.isRequired,
      state: PropTypes.string.isRequired,
      countryCode: PropTypes.string.isRequired,
      postalCode: PropTypes.string.isRequired,
    }),
  ).isRequired,
  validation: ValidationPropType,
};
